































































import AppLayout from '@/Layouts/AppLayout.vue'
import {Component, Prop, Provide} from 'vue-property-decorator';
import Vue from 'vue';
import EdelmanLogo from '@/Components/EdelmanLogo.vue';
import Form from '@/Types/Form';
import {ColumnDef} from '@/Types/VueDataTable';
import SchemaField from '@/Types/SchemaField';

@Component({
    components: {
        EdelmanLogo,
        AppLayout,
    },
})
export default class Detail extends Vue {
    @Prop({type: Object, required: true}) form!: Form
    @Prop({type: Array, required: true}) fields!: SchemaField[]

    @Provide() stringFilter: string = '';
    @Provide() onlyFlagged: boolean = false;


    onFirstDataRendered(params: {api: any}) {
      params.api.sizeColumnsToFit();
    }

    get headers(): ColumnDef[] {
        const columns: ColumnDef[] = [
            {
                prop: 'label',
            }, {
                prop: 'name',
            }, {
                prop: 'section',
            }, {
                prop: 'value',
            }, {
                prop: 'flagged',
                formatter: (row, column, value) => value ? 'Yes' : '',
            }, {
                label: 'Score',
                prop: 'score_resolved',
                formatter: (row, column, value) => `${value}/${row.score_potential}`,
            }
        ]

        return columns.map(column => ({
            label: column.label || `${column.prop.slice(0, 1).toUpperCase()}${column.prop.slice(1).toLowerCase()}`,
            formatter: column.formatter || ((row, column, value) => Array.isArray(value) ? value.join(', '): value),
            ...column,
        }));
    }

    filterFlagged(row: SchemaField): boolean {
        return this.onlyFlagged ? row.flagged === true : true;
    }

}
